import { defineStore } from 'pinia';
import axios from "axios";

export const useDocumentStore = defineStore('document', {
    state: () => ({
        documentList: {
            rca_policy_id: 1,
            vehicle_registration_id: 2,
            identity_card_id: 3,
            tax_proof_id: 4,
            diary_proof_id: 5,
            note_proof_id: 6,
        },
        acceptedFormatsForOcr: [
            'image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/heif', 'image/heic',
        ],
        acceptedFormatsForUpload: [
            'application/pdf', 'image/jpg', 'image/jpeg', 'image/png', 'image/webp'
        ],
    }),
    actions: {
        async ocrDocument(formData: FormData) {
            try {
                const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v1/documents/ocr-document`, formData);
                if (response.data.data) {
                    return response.data.data;
                }
            } catch (error) {
                throw error;
            }
            return null;
        },
    },
});
